/**
 * Drag overlay clone for preset row (pointer-events none)
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import { GripVertical } from 'lucide-react';

import type { PreparedDrop } from '@/features/smswiser-campaigns/types/workspace.types';

import type { Preset } from '../shared';
import { PresetRow } from './PresetRow';

export interface PresetRowDragOverlayProps {
  preset: Preset;
  tagColors?: Record<string, string>;
  selectedDrafts: PreparedDrop[];
  canAddToPreset: boolean;
  selectionMode: boolean;
  selected: boolean;
}

export const PresetRowDragOverlay: FC<PresetRowDragOverlayProps> = ({
  preset,
  tagColors,
  selectedDrafts,
  canAddToPreset,
  selectionMode,
  selected,
}) => (
  <div className="pointer-events-none flex w-full max-w-4xl items-stretch rounded-lg border border-border bg-background shadow-xl">
    <div className="flex shrink-0 cursor-grabbing items-center px-1 text-muted-foreground">
      <GripVertical className="h-4 w-4" />
    </div>
    <div className="min-w-0 flex-1">
      <PresetRow
        preset={preset}
        tagColors={tagColors}
        selectedDrafts={selectedDrafts}
        canAddToPreset={canAddToPreset}
        onApply={() => {}}
        onEdit={() => {}}
        onDelete={() => {}}
        onAddToPreset={undefined}
        isApplying={false}
        isBusy={false}
        selectionMode={selectionMode}
        selected={selected}
        onToggleSelected={() => {}}
      />
    </div>
  </div>
);
